import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon, faSun } from "@fortawesome/free-solid-svg-icons";
import "./Navbar.scss";
import { getNavItems } from "lib/data/navItems";
import { COLOR_MODES } from "lib/data/themes";
import { useTranslation } from "lib/i18n";
import Logo from "../../img/quivio-light.svg";

const Navbar = ({ colorMode = COLOR_MODES.DARK, onToggleColorMode = () => {} }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t, language, setLanguage } = useTranslation();
  const navItems = getNavItems(t);
  const isDarkMode = colorMode === COLOR_MODES.DARK;
  const themeToggleLabel = isDarkMode
    ? t("misc.switchToLightTheme")
    : t("misc.switchToDarkTheme");

  const handleLanguageChange = (nextLanguage) => {
    setLanguage(nextLanguage);
    setIsOpen(false);
  };

  const handleColorModeChange = () => {
    onToggleColorMode();
    setIsOpen(false);
  };

  return (
    <header className="header-transparent">
      <nav className="navbar navbar-expand-lg text-center" aria-label="Primary">
        <div className="container">
          <Link to="/" className="navbar-brand">
            <img src={Logo} alt="Quivio Logo" width={40} height={40} />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded={isOpen}
            aria-label="Toggle navigation"
            onClick={() => setIsOpen(!isOpen)}
          >
            <span className="navbar-toggler-icon">
              <i className="fi-xwluxl-three-bars-wide" aria-hidden="true"></i>
            </span>
          </button>
          <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarSupportedContent">
            <div className="nav-links-wrapper">
              <ul className="navbar-nav nav-links">
                {navItems.map((item) => {
                  return (
                    <li className="nav-item" key={item.id}>
                      <NavLink
                        exact={item.link === "/"}
                        to={item.link}
                        className="nav-link"
                        activeClassName="active"
                        onClick={() => setIsOpen(false)}
                      >
                        {item.name}
                      </NavLink>
                    </li>
                  );
                })}
              </ul>
              <div className="nav-actions">
                <div className="nav-lang">
                  <div className="language-toggle" role="group" aria-label={t("misc.languageLabel")}>
                    <button
                      type="button"
                      className={`lang-button ${language === "en" ? "active" : ""}`}
                      onClick={() => handleLanguageChange("en")}
                      aria-pressed={language === "en"}
                      aria-label={t("misc.languageEnglish")}
                    >
                      EN
                    </button>
                    <button
                      type="button"
                      className={`lang-button ${language === "fr" ? "active" : ""}`}
                      onClick={() => handleLanguageChange("fr")}
                      aria-pressed={language === "fr"}
                      aria-label={t("misc.languageFrench")}
                    >
                      FR
                    </button>
                  </div>
                </div>
                <button
                  type="button"
                  className="color-mode-toggle"
                  onClick={handleColorModeChange}
                  aria-label={themeToggleLabel}
                  aria-pressed={isDarkMode}
                  title={themeToggleLabel}
                >
                  <FontAwesomeIcon icon={isDarkMode ? faMoon : faSun} aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
